module.exports = __webpack_public_path__ + "img/google_play_button.cd654a36.png";